<div class="sf-section photographer-portfolio">
  <h2 class="photographer-portfolio__title">{{'marketplace.photographer.portfolio.title'|transloco}}</h2>

  <div class="photographer-portfolio-grid">
    @if (portfolio === null) {
        <div class="photographer-portfolio-grid__item skeleton-loading"></div>
        <div class="photographer-portfolio-grid__item skeleton-loading"></div>
        <div class="photographer-portfolio-grid__item skeleton-loading"></div>
        <div class="photographer-portfolio-grid__item skeleton-loading"></div>
    } @else {
      @for (photo of portfolio; track photo; let i = $index) {
        <button
          type="button"
          class="photographer-portfolio-grid__item"
          (click)="openCarousel(i)"
        >
          <app-image
            [src]="photo.url"
            [alt]="'Portfolio ' + (i + 1)"
            preset="card"
            aspectRatio="0.75"
            [sizes]="'(max-width: 600px) calc((100vw - 16px)/2), 428px'"
            [priority]="i < 2">
          </app-image>
        </button>
      }
    }
  </div>
</div>

<app-carousel
  [photos]="portfolio"
  [open]="carouselOpen"
  [index]="carouselIndex"
  (onClose)="closeCarousel()"
></app-carousel>
